module.exports = __webpack_public_path__ + "img/skull.3eea3fc0.png";